import { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from '../components/Modal';
import generateBarcode from '../components/barcodeHelper';
import { toast } from 'react-toastify';

const CarrefourEcommerce = ({ selectedTag, selectedDefaultWarehouse }) => {
  const [products, setProducts] = useState([]);



  const [formData, setFormData] = useState({
    interne_code: '',
    bar_code: '',
    name: '',
    id_erp: '',
    price: '',
    products: [],
  });
  const barcodeGen = () => {
    setFormData((prev) => ({
      ...prev,
      ['bar_code']: generateBarcode()?.barcodeValue,
    }));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { interne_code, bar_code, name, price } = formData;

    if (!interne_code || !bar_code || !name || !price) {
      alert('Veuillez remplir tous les champs obligatoires.');
      return;
    }

    const response = await axios.post(process.env?.REACT_APP_PEGASUS_API_URL + '/carrefour/product', formData, {
      headers: {
        'ENCRYKEY': process.env?.REACT_APP_KEY_PEGASUS,
      },
    });
    if (response.status == 201) {
      toast.success("Réference Ajouté avec succès");
      fetchProducts();
    } else {
      toast.error("Une Erreur est survenu lors de l'ajout de la réference");
    }

   
  };
  const fetchProducts = async () => {


    try {
      const response = await axios.get(
        process.env?.REACT_APP_PEGASUS_API_URL + '/carrefour/products',
        {
          headers: {
            'ENCRYKEY': process.env?.REACT_APP_KEY_PEGASUS,
          },
        }
      );
      if (response.status == 200) {
        setProducts(response.data);
      }

    } catch (error) {
      console.error('Error fetching products:', error);
    }

  };

  useEffect(() => {
    

    fetchProducts();
  }, []); // Runs once when the component mounts




  return (
    <div>
      <h2>Produits </h2>
      <div className='text-end'><button data-bs-toggle="modal" data-bs-target="#refAddCarrefour">Ajouter une référence</button></div>
      {products.length > 0 ? (
        <table border="1" className="table table-striped mt-5">
          <thead className='bg-danger '>
            <tr>
              <th>Label</th>
              <th>Barcode</th>
              <th>Price (TTC)</th>
              <th>Ajouter un produit</th>

            </tr>
          </thead>
          <tbody>
            {products.map((product, index) => {

              return (
                <tr>
                  <td>{product.name}</td>
                  <td>{product.bar_code}</td>
                  <td><strong>{Math.round(product.price)}</strong> DHS</td>
                  <td></td>
                </tr>



              )
            }
            )
            }
          </tbody>
        </table>
      ) : <>erreur</>
      }
      <Modal title="Ajout d'une référence Carrefour" modalId="refAddCarrefour" submitLabel="Ajouter" onSubmit={handleSubmit} >
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Code Interne</label>
            <input
              type="text"
              name="interne_code"
              className="form-control"
              value={formData.interne_code}
              onChange={handleChange}
              required
            />
          </div>

          <div className='row'>
            <div className='col-8'>
              <div className="mb-3">
                <label className="form-label">Code Barre</label>
                <input
                  type="text"
                  name="bar_code"
                  className="form-control"
                  value={formData.bar_code}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className='col-4 d-flex align-items-end'>
              <div className="mb-3 w-100">
                <button className='btn btn-success w-100' onClick={barcodeGen}>Générer</button>
              </div>
            </div>
          </div>


          <div className="mb-3">
            <label className="form-label">Nom</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Prix</label>
            <input
              type="number"
              name="price"
              className="form-control"
              value={formData.price}
              onChange={handleChange}
              required
            />
          </div>


        </form>
      </Modal>


    </div>
  );
};

export default CarrefourEcommerce;